import React from 'react'
import { connect } from 'react-redux'

const Toast = ({ toast }) => {
  if (toast.showToast) {
    return (
      <div className="toast" style={{ backgroundColor: toast.toastColor }}>
        { toast.toastMessage }
      </div>
    )
  }
  return null
}
function mapStateToProps ({ toast }) {
  return { toast }
}
export default connect(mapStateToProps, null)(Toast)



// WEBPACK FOOTER //
// ./src/components/_common/Toast.js